import http from './httpService';
import config from './config.json';


export const getCart = () => {
    return http.get(`${config.bestlearnapi}/customer/cart`);
};

export const addToCart = (courseId: string) => {
    return http.post(`${config.bestlearnapi}/customer/cart/${courseId}`);
};


export const deleteFromCart = (courseId: string) => {
    return http.delete(`${config.bestlearnapi}/customer/cart/${courseId}`);
};

export const deleteFromCartMulti = (courseId: string) => {
    return http.delete(`${config.bestlearnapi}/customer/cart/multi/${courseId}`);
};

export const clearCart = () => {
    return http.delete(`${config.bestlearnapi}/customer/cart`);
};

